import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PropTypes from "prop-types";
import ReactCountryFlag from "react-country-flag";

import CustomCheckBox from "../../../components/CheckBox/index";
import trashIcon from "../../../assets/images/trash.svg";

const AccessList = ({
  allservices,
  accesslists,
  paginationOnchange,
  paginationFisrt,
  paginationRows,
  hanleChangeUpdateAccess,
  updatEntity,
  openDeleteModal,
}) => {
  return (
    <DataTable
      value={accesslists}
      sortMode="multiple"
      paginator={accesslists?.length > 10}
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      rowsPerPageOptions={[10, 20, 30]}
      first={paginationFisrt}
      rows={paginationRows}
      onPage={paginationOnchange}
      emptyMessage="No results were found"
    >
      <Column
        header="Entity"
        sortable
        field="entity.name"
        className="table-col"
        body={(data) => {
          const countryCode = data?.entity?.country || "";
          return (
            <p>
              <ReactCountryFlag
                countryCode={countryCode}
                svg
                className="mr-2"
              />
              {`${data?.entity?.name} (${data?.entity?.country})`}
            </p>
          );
        }}
      />

      {allservices.map((item) => {
        return (
          <Column
            align="center"
            key={item.id}
            header={item.name}
            className="table-col"
            body={(data) => {
              const isActive = data?.entity?.active_services?.includes(item.id);
              const isData = data?.services?.some(
                (service) => service.id === item.id,
              );
              const isavailble = updatEntity.find(
                (x) =>
                  x.entityId === data?.entity?.id && x.serviceId === item.id,
              );

              const isChecked = isavailble ? isavailble.checked : isData;
              return (
                <CustomCheckBox
                  inputId={`checkbox-${item.id}`}
                  disabled={!isActive}
                  checked={isChecked || false}
                  onChange={(e) => {
                    hanleChangeUpdateAccess(
                      e.target.checked,
                      data?.entity.id,
                      item.id,
                    );
                  }}
                />
              );
            }}
          />
        );
      })}

      <Column
        header="Actions"
        className="table-col"
        align="center"
        body={(rowData) => (
          <img
            src={trashIcon}
            alt="Delete"
            style={{ width: "22px", cursor: "pointer" }}
            onClick={() => openDeleteModal(rowData?.entity)}
          />
        )}
      />
    </DataTable>
  );
};
AccessList.propTypes = {
  id: PropTypes.string,
  activeTab: PropTypes.bool,
  allservices: PropTypes.array,
  accesslists: PropTypes.array,
  paginationOnchange: PropTypes.func,
  paginationFisrt: PropTypes.number,
  paginationRows: PropTypes.number,
  hanleChangeUpdateAccess: PropTypes.func,
  updatEntity: PropTypes.array,
  openDeleteModal: PropTypes.bool,
};
export default AccessList;
